import { createSlice } from '@reduxjs/toolkit';
import { _CreditListLinks, Credit } from 'types/api.types';
import {
  fetchCreditsDetailsEffect,
  fetchCreditsListEffect,
} from 'app/store/Contributions/effects';
import { GenericObject } from 'types/generic.types';
import { ContributionsList } from 'types/contribution';

export interface ContributionsState {
  creditsList?: Credit[];
  _creditListLinks?: _CreditListLinks;
  creditsDetails: GenericObject<ContributionsList>;
}

export const contributionsInitialState: ContributionsState = {
  creditsDetails: {},
};

const slice = createSlice({
  name: 'contribution',
  initialState: contributionsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCreditsListEffect.fulfilled, (state, { payload }) => {
        if (!payload) {
          return;
        }
        state.creditsList =
          payload.isNext && state.creditsList
            ? state.creditsList.concat(payload.items)
            : payload.items;
        state._creditListLinks = payload._links;
      })
      .addCase(fetchCreditsDetailsEffect.fulfilled, (state, { payload }) => {
        state.creditsDetails[payload.songGuid] = payload.contributions;
      });
  },
});

export const contributionsReducer = slice.reducer;
